import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import MonthlyDetailSection from '../components/MonthlyDetailSection';
import ProcessSection from '../components/ProcessSection';
import BookingForm from '../components/BookingForm';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import GallerySection from '../components/GallerySection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <HeroSection />
      <ServicesSection />
      <MonthlyDetailSection />
      <ProcessSection />
      <BookingForm />
      <BeforeAfterSlider />
      <GallerySection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default Home;
